import React from 'react';
import { Route } from 'react-router-dom';
import AuthorLayout from '../modules/author/AuthorLayout';
import PaperSubmit from '../modules/author/PaperSubmit';
import ReviewerDecision from '../modules/author/ReviewerDecision';
import PaperProgress from '../modules/author/PaperProgress';
// import SubmissionHistory from '../modules/author/SubmissionHistory';
// import AuthorReply from '../modules/author/AuthorReply';
import AuthorDashboard from '../modules/author/AuthorDashboard';
import LoginForm from '../modules/author/LoginForm';
import RegistrationForm from '../modules/author/RegistrationForm';
import AuthorTotalPaper from '../modules/author/AuthorTotalPaper';
import AuthorAcceptedPapers from '../modules/author/AuthorAcceptedPapers';
import ProtectedRoute from './ProtectedRoute';

const AuthorRoutes = (
  <>
    <Route path="/login" element={<LoginForm />} />
    <Route path="/register" element={<RegistrationForm />} />
    {/* <Route path="/submission-history" element={<SubmissionHistory />} />
    <Route path="/reply" element={<AuthorReply />} /> */}
    {/* <Route path="/dashboard" element={<AuthorDashboard />} /> */}

    <Route element={<ProtectedRoute requiredRole="author" />}>
      <Route path="/author" element={<AuthorLayout />}>
        <Route path="reset-password" element={<AuthorDashboard />} />
        <Route path="dashboard" element={<AuthorDashboard />} />
        <Route path="papersubmit" element={<PaperSubmit />} />
        <Route path="reviewer-decision" element={<ReviewerDecision />} />
        <Route path="paper-progress" element={<PaperProgress />} />
        <Route path="all-papers" element={<AuthorTotalPaper />} />
        <Route path="accepted-papers" element={<AuthorAcceptedPapers />} />
      </Route>
    </Route>
  </>
);

export default AuthorRoutes;
